export default "__VITE_ASSET__M1YOumZ5__"